import React, { useEffect, useState } from "react";
import Axios from "axios";
import TextField from "@mui/material/TextField";
import Navbar from "./Navbar";
import { useParams, useHistory } from "react-router-dom";
import Loading from "./Components/Loading";
import { message, Spin } from "antd";

function EditSource() {
  Axios.defaults.withCredentials = true;
  const [list, setList] = useState([]);
  const params = useParams();
  const history = useHistory();

  useEffect(() => {
    document.title = "Update Source";
  }, []);

  useEffect(() => {
    Axios.get("/api/source/readOneSource/" + params.id).then((response) => {
      setList(response.data.source);
    });
  }, []);

  const [description, setDescription] = useState(list.SourceName);
  const [descriptionError, setDescriptionError] = useState(false);
  const [source, setSource] = useState(list.Description);
  const [sourceError, setSourceError] = useState(false);
  const [loading, setLoading] = useState(false);

  const addToList = () => {
    setDescriptionError(false);
    setSourceError(false);

    if (source === "") {
      setSourceError(true);
      return;
    }

    if (description === "") {
      setDescriptionError(true);
      return;
    }
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    Axios.put(
      "/api/source/modifySource/" + params.id,
      {
        SourceName: source,
        Description: description,
      },
      config
    )
      .then(function (response) {
        message.success(" Updated successfully");
        setTimeout(function () {
          history.push("/sourcelist");
        }, 1000);
      })
      .catch(function (error) {
        message.error(`${error.response.data.message}`);
      });
  };

  return (
    <>
      {loading && <Loading />}
      <Navbar title="Update Source" />
      <div
        className="container-fluid pt-4"
        style={{ backgroundColor: "#F0F2FA" }}
      >
        <div
          style={{
            paddingLeft: "20px",
            paddingBottom: "10px",
            fontSize: "25px",
          }}
        >
          {/* <h2>Update Source</h2> */}
        </div>
        <div className="row mt-3 mb-4 pr-3 pl-3">
          <div className="col-lg-12">
            <div className="card" style={{ backgroundColor: "#F3F3F3" }}>
              <div className="card-body " key={list._id}>
                <div className="row form-group  " style={{ padding: "10px" }}>
                  <div className="col-lg-6">
                    <TextField
                      defaultValue={list.SourceName}
                      className="lead-fields"
                      required
                      fullWidth
                      id="outlined-required"
                      label="Source Name"
                      onChange={(e) => setSource(e.target.value)}
                      error={sourceError}
                    />
                  </div>

                  <div className="col-lg-6">
                    <TextField
                      defaultValue={list.Description}
                      className="lead-fields"
                      required
                      fullWidth
                      id="outlined-required"
                      label="Description"
                      onChange={(e) => setDescription(e.target.value)}
                      error={descriptionError}
                    />
                  </div>
                </div>

                <div
                  className="float-right pr-3 "
                  style={{ paddingTop: "40px" }}
                >
                  {" "}
                  <button
                    onClick={addToList}
                    className="btn btn-primary add-button"
                  >
                    {" "}
                    Update Source{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EditSource;
